/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeebuyerhint3Inputs */

const en_ticketsfeebuyerhint3 = /** @type {(inputs: Ticketsfeebuyerhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The fee is added to the price at checkout. Applies to all your events.`)
};

const de_ticketsfeebuyerhint3 = /** @type {(inputs: Ticketsfeebuyerhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gebühr kommt beim Kauf auf den Preis drauf. Gilt für alle deine Events.`)
};

/**
* | output |
* | --- |
* | "The fee is added to the price at checkout. Applies to all your events." |
*
* @param {Ticketsfeebuyerhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeebuyerhint3 = /** @type {((inputs?: Ticketsfeebuyerhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeebuyerhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeebuyerhint3(inputs)
	return de_ticketsfeebuyerhint3(inputs)
});
export { ticketsfeebuyerhint3 as "ticketsFeeBuyerHint" }